module.exports = __webpack_public_path__ + "img/image2.af1513f7.jpg";